import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const setSkillMapTrade = api(async function setSkillMapTrade({ skillMapId, tradeId, name }) {
    return mutate(
        gql`
            mutation SetSkillMapTrade($skillMapId: String!, $tradeId: String!, $name: String!) {
                setSkillMapTrade(skillMapId: $skillMapId, tradeId: $tradeId, name: $name)
            }
        `,
        { skillMapId, tradeId, name },
        { returns: "setSkillMapTrade" }
    )
})
